import { barcodeBackendAxios } from './barcodeBackendAxios';
import {
	CreateMemberBulkType,
	MemberInfoType,
	MissionUsageInfoType,
	TicketBaseInfoType,
	TicketMappingInfoType,
	바코드총에서얻는티켓매핑Type,
} from './mappingTicketType';

export const MappingTicketApis = {
	getTicketMappingInfoListForOrder: async ({ orderIdList }: { orderIdList: string[] }) => {
		const result = await barcodeBackendAxios.get<바코드총에서얻는티켓매핑Type[]>(
			`/mapping-ticket/orders/member`,
			{
				params: {
					orderIdList,
				},
			}
		);
		return result.data;
	},

	getTicketMappingInfo: async ({ ticketId }: { ticketId: string }) => {
		const result = await barcodeBackendAxios.get<TicketMappingInfoType>(`/mapping-ticket`, {
			params: {
				ticketId,
			},
		});
		return result.data;
	},

	getMissionUsageInfo: async ({ ticketId }: { ticketId: string }) => {
		const result = await barcodeBackendAxios.get<MissionUsageInfoType>(
			`/mapping-ticket/${ticketId}/full`
		);
		return result.data;
	},

	createMember: async (data: { ticketId: string; memberInfo: MemberInfoType }) => {
		const result = await barcodeBackendAxios.post<TicketBaseInfoType>(
			`/mapping-ticket/${data.ticketId}/member`,
			data.memberInfo
		);

		return result.data;
	},

	createMemberBulk: async (data: CreateMemberBulkType) => {
		const result = await barcodeBackendAxios.post<TicketBaseInfoType[]>(
			`/mapping-ticket/bulk/member`,
			data
		);
		return result.data;
	},

	updateMember: async (data: { memberInfo: MemberInfoType }) => {
		const result = await barcodeBackendAxios.put<MemberInfoType>(
			`/mapping-ticket/member/${data.memberInfo.id}`,
			data.memberInfo
		);

		return result.data;
	},

	updateMapping: async (data: { ticketId: string; memberId: number }) => {
		const result = await barcodeBackendAxios.put<TicketBaseInfoType>(
			`/mapping-ticket/mapping`,
			{},
			{
				params: {
					ticketId: data.ticketId,
					mappingMemberId: data.memberId,
				},
			}
		);

		return result.data;
	},

	deleteMember: async (data: { memberId: number }) => {
		const result = await barcodeBackendAxios.delete(`/mapping-ticket/member`, {
			params: {
				memberId: data.memberId,
			},
		});

		return result.data;
	},
};
